module.exports = {
  couple: 'couple',
  therapist: 'Therapist',
  room: 'Room',
  paidOn: 'Paid on',
  unpaid: 'Unpaid',
  hasBeen: 'Has been',
  locked: 'locked',
  shifted: 'shifted | and shifted',
  hasNote: 'Has a note',
}
